/**
 * Created by istvan.rozsa on 2017. 03. 28..
 */
export default function downloadDocument(app) {
	app.directive('downloadDocument', [
		function () {
			return {
				restrict: 'E',
				scope: {
					docArray: '=',
					zipDownloadUrl: '@',
					buttonLabel: '@'
				},
				templateUrl: 'common/downloader-form',
				link: function ($scope) {
					$scope.downloadInProgressSafari = false;
					$scope.downloadSelectedInvoices = function () {
						var data = [];

						for (var i = 0; i < $scope.docArray.length; i++) {
							if ($scope.docArray[i].hasOwnProperty('selected') && $scope.docArray[i].selected === true) {
								data.push({
									docname: $scope.docArray[i].docname,
									docid: $scope.docArray[i].docid
								});
							}
						}

						var downloadableInput = angular.element('#downloadable')[0];
						var downloaderForm = angular.element('#downloaderForm')[0];
						downloadableInput.value = JSON.stringify(data);
						downloaderForm.submit();

						$scope.downloadInProgressSafari = true;

						// Safari esetén van szükség erre, 2 mp után elrejtjük a popupot
						setInterval(() => {
							$scope.$emit('handleSafariDownload');
							$scope.downloadInProgressSafari = false;
						}, 2000);
					};
				}
			};
		}
	]);
}
